import { render, staticRenderFns } from "./AttachmentImgList.vue?vue&type=template&id=bfdeb0ae&scoped=true&"
import script from "./AttachmentImgList.vue?vue&type=script&lang=js&"
export * from "./AttachmentImgList.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentImgList.vue?vue&type=style&index=0&id=bfdeb0ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdeb0ae",
  null
  
)

export default component.exports